module.exports = __webpack_public_path__ + "img/flaggstikk3.721c7306.jpg";